import { connect } from "react-redux";
// import { requestAdminAmcs } from "src/redux/actions";
import GeneratedLink from "./generated-link";

const mapStateToProps = (state) => ({
  createdDesposit: state.adminDeposits?.createdDesposit,
});

export default connect(mapStateToProps, {})(GeneratedLink);
